module.exports = __webpack_public_path__ + "42549289b9de6dff5af6ec384a2a4bf8.png";